import { createReactContextStore } from 'src/researcher/context/store';
import { ScrollProviderState } from './scroll.types';

enum ScrollActionName {
  SetHasScrolled = 'rshr/scroll/set_has_scrolled',
}

interface SetScrolledAction {
  type: ScrollActionName.SetHasScrolled;
  payload: {
    hasScrolled: boolean;
  };
}

function scrollReducer(state: ScrollProviderState, action: SetScrolledAction): ScrollProviderState {
  switch (action.type) {
    case ScrollActionName.SetHasScrolled: {
      return {
        ...state,
        hasScrolled: action.payload.hasScrolled,
      };
    }
    default: {
      return state;
    }
  }
}

export const setHasScrolledAction = (hasScrolled: boolean): SetScrolledAction => ({
  type: ScrollActionName.SetHasScrolled,
  payload: {
    hasScrolled,
  },
});

export const ScrollInitState = {
  hasScrolled: false,
  element: 'header',
  shouldBubbleOnScroll: false,
};
const { Provider, useState, useStore, useDispatch } = createReactContextStore<
  ScrollProviderState,
  SetScrolledAction
>('Scroll', scrollReducer);

export const ScrollProvider = Provider;
export const useScrollState = useState;
export const useScrollDispatch = useDispatch;
export const useScrollStore = useStore;
